/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminCompanyOverviewDto { 
    id?: number;
    companyName?: string;
    companyNo?: string;
    verificationStatus?: string;
    created?: string;
    programStatus?: string;
    memberCount?: number;
    scansLast30Days?: number;
    email?: string;
    phone1?: string;
    contactName?: string;
    rejectReason?: string;
    proofUploaded?: boolean;
    transactionCount?: number;
}

